<template>
	<div class="account-payments card">
		<div class="header4">Account Payments</div>
		<div class="paragraph">
			Use the link below to add a credit card payment. Please note we only store one payment method at a time. Adding a new payment method will
			replace your existing payment method.
		</div>
		<!-- <PaymentItem :isPaypal="false" />
		<PaymentItem :isPaypal="true" /> -->
		<div id="dropin-container" />
		<Button v-if="readyToSave" title="Update Payment" :onClick="updateCreditCard" />
	</div>
</template>

<script>
import Button from "@/components/ui/Button.vue";
import PaymentItem from "@/components/account/PaymentItem.vue";
import api from "@/store/utils/api";
import dropin from "braintree-web-drop-in";
export default {
	name: "account-payments",
	components: { PaymentItem, Button },
	data() {
		return {
			token: "",
			instance: null,
			readyToSave: false,
		};
	},
	methods: {
		updateCreditCard() {
			this.instance.requestPaymentMethod(function (err, payload) {
				// Send payload.nonce to your server.
				api.post("/api/v1/user/update-payment", {
					nonce: payload.nonce,
					deviceData: null,
				});
			});
		},
	},
	async mounted() {
		const data = await api.get("/api/v1/user/payment-token");
		this.token = data.token;
		dropin.create(
			{
				authorization: data.token,
				vaultManager: false,
				container: "#dropin-container",
				styles: {
					input: {
						"font-style": "normal",
						"font-weight": "300",
						"font-size": "16px",
						"line-height": "200%",
						background: "red",
					},
				},
				card: {
					cardholderName: {
						required: true,
						// to make cardholder name required
						// required: true
					},
					cvv: {
						required: true,
						// to make cardholder name required
						// required: true
					},

					postalCode: {
						required: true,
					},
					overrides: {
						fields: {
							number: {
								maskInput: {
									showLastFour: true,
								},
							},
							cvv: {
								maskInput: true,
							},
						},
					},
				},
			},
			(createErr, instance) => {
				this.instance = instance;
				this.instance.on("paymentMethodRequestable", (event) => {
					this.readyToSave = !event.paymentMethodIsSelected;
				});
				this.instance.on("noPaymentMethodRequestable", () => {
					this.readyToSave = true;
				});
			},
		);
	},
};
</script>

<style scoped lang="scss">
.account-payments {
	padding: 25px;
	text-align: left;
	.header4 {
		color: var(--dark-gray);
	}
	.paragraph {
		color: var(--dark-gray);
		margin-top: 15px;
		opacity: 0.5;
		margin-bottom: 20px;
	}
	.payment-item:nth-last-child(1) {
		border-bottom: unset;
	}
	.payment-item {
		border-bottom: 2px solid var(--light-gray);
		padding-bottom: 20px;
		padding-top: 20px;
		max-width: 550px;
	}
}
</style>
